/* global $ */
import { Swiper, Navigation, Pagination, Autoplay, EffectFade } from 'swiper/dist/js/swiper.esm.js'

Swiper.use([Navigation, Pagination, Autoplay, EffectFade])

function init () {
  $(document).ready(function () {
    // initialize swiper when document ready
    const swiperElem = $('.swiper-container.post-swiper')
    if (swiperElem.length === 0) {
      return
    }
    const swiper = new Swiper(swiperElem, {
      loop: false,
      watchOverflow: true,
      autoHeight: false,
      slidesPerView: 3,
      navigation: {
        nextEl: $('.posts').find('.swiper-button-next'),
        prevEl: $('.posts').find('.swiper-button-prev')
      },
      breakpoints: {
        1000: {
          slidesPerView: 1,
        }
      }
    })
    swiper.init()
  })
}

export default {
  init
}
